//Lib  

// Extend
import baseExtraService from '@/scripts/extraService/baseExtraService';

// Api
import api from '@/api/baseApi';

// Constant
import { REGEX, API_CALL_STATUS, POPUP_ID } from "@/constant/baseConstant";
import { SERVICE_TYPE, MACHINE_LIST_FILTER_BY } from '@/constant/rental';
import { SETTINGS_RENTAL_API, SETTINGS_EXTRA_SERVICE_API } from "@/constant/apiSettings";
import { EXTRA_SERVICE_TYPE, ERROR_CODE_OPEN_PORT } from "@/constant/extraService";

// Component  

// Function 
const queryString = require('query-string');

export default {

    extends: baseExtraService,

    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },

    data() {

        return {
            machineListRequest: {
                serviceType: SERVICE_TYPE.GPUHUB,
                filterBy: MACHINE_LIST_FILTER_BY.FIXED_RENTAL,
                orderBy: 'A.CREATED_AT',
                directionSort: 'DESC',
            },

            listPort: null,
            note: null,

            machineList: null,
            machineIdTarget: null,

            checking: false,

            notify: {
                portMsg: null,
                colorMsg: null,
            },

            disabledSelectMachine: false,
            canSendRequest: false,
        };
    },

    mounted() {
        if (this.targetImage) {
            this.disabledSelectMachine = true;
            this.machineList = [this.targetImage];
            this.machineIdTarget = this.targetImage.id;
        } else {
            this.machineListView();
        }
    },

    methods: {

        //#region Processing event
        processingEvent(param) {
            this[param.event](param.data);
        },
        //#endregion

        //#region Close pop-up
        closeThisPopup() {
            this.closePopup(POPUP_ID.EXTRA_SERVICE_OPEN_PORT);
        },
        //#endregion

        //#region Machine list view
        machineListView() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            api.baseRequest(SETTINGS_RENTAL_API.MACHINE_LIST_VIEW, null, `?${queryString.stringify(this.machineListRequest)}`)
                .then((res) => {
                    this.machineList = res.data;
                    if (this.machineList && this.machineList.length > 0) {
                        this.isShowErrorInformation = false;
                    } else {
                        this.isShowErrorInformation = true;
                    }
                    this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.machineList);
                })
                .catch(error => {
                    this.processCatchApiRequest(error, "Request failed ...")
                });
        },
        //#endregion

        //#region Verify port
        verifyPort() {
            this.listPort = this.listPort.replace(/^([,]+)/g, "");
            this.listPort = this.listPort.replace(/([,]+)$/g, "");
            this.listPort = this.listPort.replace(/([,]+)/g, ",");
            if (this.listPort.match(REGEX.multiPort)) {
                this.checkAvailablePort();

            } else {
                this.notify = {
                    colorMsg: "red",
                    portMsg: "Enter in incorrect format"
                };
            }
        },
        //#endregion 

        //#region Check available port
        checkAvailablePort() {
            this.checking = true;
            this.canSendRequest = false;
            let data = {
                listPort: this.listPort.split(",").map(i => Number(i)),
                deviceInformation: JSON.stringify(this.getInformationClient())
            }
            setTimeout(() => {
                api.baseRequest(SETTINGS_EXTRA_SERVICE_API.CHECK_PORT, data)
                    .then((res) => {
                        if (res.data) {
                            this.canSendRequest = true;
                            this.notify = {
                                colorMsg: "forestgreen",
                                portMsg: "Congratulations all your ports are available !"
                            };
                        } else {
                            this.canSendRequest = false;
                            this.notify = {
                                colorMsg: "darkorange",
                                portMsg: "Ports not available"
                            };
                        }
                        this.checking = false;
                    })
                    .catch(error => {
                        this.checking = false;
                        this.processCatchApiRequest(error, "Rental Plan failed ...")
                    });
            }, this.smoothTimeOut);
        },
        //#endregion 

        //#region Open port send request
        send() {
            this.feedStatusLoading(API_CALL_STATUS.LOADING);
            setTimeout(() => {
                let data = {
                    type: EXTRA_SERVICE_TYPE.OPEN_PORT,
                    machineId: this.machineIdTarget,
                    listPort: this.listPort.split(",").map(i => Number(i)),
                    note: this.note,
                    deviceInformation: JSON.stringify(this.getInformationClient())
                }
                this.createRequest(
                    data,
                    () => { this.closeThisPopup() }
                )
            }, this.smoothTimeOut);
        },
        //#endregion
    },
}